import { HStack, Icon, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { FiPlus } from "react-icons/fi";
import CDS from "design-system";

import { FIELD_TYPE_ICON, FIELD_TYPE_LABEL, FIELD_TYPES_IN_PALETTE_ORDER } from "../../constants";
import type { CustomFormFieldType } from "../../types";

interface Props {
  onAdd: (type: CustomFormFieldType) => void;
}

/** Trailing add affordance below the field list; opens a field-type menu. */
export default function AddFieldButton({ onAdd }: Props) {
  return (
    <Menu placement="bottom" autoSelect={false}>
      <MenuButton
        as={CDS.Button}
        w="100%"
        h="40px"
        bg="cdsIndigo.500"
        color="white"
        fontWeight="medium"
        borderRadius="base"
        _hover={{ bg: "cdsIndigo.600" }}
        _active={{ bg: "cdsIndigo.700" }}
      >
        <HStack spacing={2} justify="center">
          <Icon as={FiPlus} boxSize={4} color="white" />
          <CDS.Text14 as="span" color="white" fontWeight="medium">Add field</CDS.Text14>
        </HStack>
      </MenuButton>
      <MenuList>
        {FIELD_TYPES_IN_PALETTE_ORDER.map((type) => (
          <MenuItem
            key={type}
            icon={<Icon as={FIELD_TYPE_ICON[type]} boxSize={4} />}
            onClick={() => onAdd(type)}
          >
            {FIELD_TYPE_LABEL[type]}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
